import { type FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@~/hooks';

import { DASHBOARD_ROUTES } from '../route-constants';

// Imported lazily
const AuthRoutesWrapper: FC = () => {
  const loggedIn = useAppSelector(store => store.auth.loggedIn);

  if (loggedIn) {
    return <Navigate to={DASHBOARD_ROUTES.ROOT.PATH} replace />;
  }

  return <Outlet />;
};

export default AuthRoutesWrapper;
